import { useThemeObserver } from '@atlaskit/tokens/use-theme-observer';
import type { AiPlannerColorMode } from './getAiPlannerUrl.tsx';

/**
 * Jira's current color mode (light/dark), for building the planner embed url.
 *
 * Reads Jira's live theme state via `useThemeObserver` (backed by Jira's
 * `data-color-mode` attribute) — this is deliberately NOT the OS/browser
 * `prefers-color-scheme` preference, since Jira's theme and the OS preference
 * can diverge (e.g. Jira pinned to dark while the OS is light). The value
 * updates whenever Jira's theme changes, so callers can react (e.g. reload an
 * already-mounted planner iframe) instead of reading it only once.
 *
 * Falls back to 'light' when the theme hasn't resolved yet (e.g. very first
 * paint, before `<html>` has a `data-color-mode` attribute).
 */
export const useAiPlannerColorMode = (): AiPlannerColorMode => {
	const { colorMode } = useThemeObserver();
	return colorMode === 'dark' ? 'dark' : 'light';
};
